export const INBOX_TYPES = {
  WEB: 'Channel::WebWidget',
  FB: 'Channel::FacebookPage',
  TWITTER: 'Channel::TwitterProfile',
  TWILIO: 'Channel::TwilioSms',
  WHATSAPP: 'Channel::Whatsapp',
  API: 'Channel::Api',
  EMAIL: 'Channel::Email',
  TELEGRAM: 'Channel::Telegram',
  LINE: 'Channel::Line',
  SMS: 'Channel::Sms',
  SMS_BRANA: 'Channel::SmsBrana',
  DIDWW: 'Channel::Didww',
  INSTAGRAM: 'Channel::Instagram',
  PHONE: 'Channel::Phone',
  SALESFORCE: 'Channel::Salesforce',
  ALLEGRO: 'Channel::Allegro',
  KAUFLAND: 'Channel::Kaufland',
};
